// libs
import classNames from 'classnames'
import * as React from 'react'

// components
import Logo, { ILogos } from 'src/components/logo/logo'

// interfaces & constants
import { CLASS_PREFIX } from 'src/constants/'
import { PageTitlePossibleTags } from 'src/containers/smart_components/page_title/page_title'
import { getConfigValue } from 'src/utils/config/config'

// helpers
import { FeatureFlag } from '../../../feature_flag/feature_flag'
import { PageTitleContent } from './page_title_content'

import { useFeatureFlags } from '@lopo-tech/frontends-shared'
import { useGlobalPermissions, useUser } from '@lopo-tech/lopo-api'
import { useHistory } from 'react-router-dom'
import { Button } from 'src/components/button/button'
import { FRONTEND_CREATE_PROFILE } from 'src/constants/urls'
import { textResources } from 'src/lang/de'
import './page_title.scss'

const cls = `${CLASS_PREFIX}page-title`

interface IProps {
  customTag?: PageTitlePossibleTags;
  isHome?: boolean;
  location?: string;
  showLocation?: boolean;
  text: string;
}

const PageTitle: React.FC<IProps> = (props) => {
  const customLogoType = getConfigValue<keyof ILogos>(
    'featureFlags.header.logoType'
  )
  const { canCreateBlogProfile } = useGlobalPermissions()
  const { data } = useUser()

  const features = useFeatureFlags()

  const hasNoPublicProfile = data && !data?.me.blogProfiles.length

  const history = useHistory()

  return (
    <div className={cls + '__container'}>
      <FeatureFlag
        active={getConfigValue('featureFlags.header.replaceWithLogo')}
        fallback={<PageTitleContent {...props} cls={cls} />}
      >
        <span
          className={classNames(
            `${cls}__logo`,
            customLogoType && `${cls}__logo--${customLogoType}`
          )}
        >
          <Logo type={customLogoType || 'NO_TEXT'} />
        </span>
      </FeatureFlag>
      <FeatureFlag active={features.showPublicProfileCtas}>
        {canCreateBlogProfile && hasNoPublicProfile && (
          <div className={cls + '__create-public-profile'}>
            <Button
              variant="secondary"
              title={textResources.createPublicProfile.ctaButtonText}
              onClick={() => {
                history.push(FRONTEND_CREATE_PROFILE)
              }}
            />
          </div>
        )}
      </FeatureFlag>
    </div>
  )
}

export default PageTitle
